import Grid from "@mui/material/Grid";
import { Outlet } from "react-router-dom";

export default function UserPreferencesMainGrid() {
  return (
    <Grid
      container
      spacing={2}
      columns={12}
      sx={{ mb: (theme) => theme.spacing(2) }}
    >
      <Grid size={{ sm: 12 }}>
        <Outlet />
      </Grid>
    </Grid>
  );
}
